import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'c-3po';

import {
    MESSAGE_STATUS_NOT_DELIVERED,
    MESSAGE_STATUS_SENDING,
} from '@evo/chat-core';

// styles
import css from './processingMessage.sss';


const STATUSES = [
    MESSAGE_STATUS_SENDING,
    MESSAGE_STATUS_NOT_DELIVERED
];


export const Processing = ({ status, retry, msgId, isSpellingError, isFilesSizeError=false, isFilesSaveError=false  }) => {
    const canRetry = status === STATUSES[1] && (!isSpellingError && !isFilesSizeError || isFilesSaveError);
    return (
        <React.Fragment>
            {STATUSES.indexOf(status) > -1 && (
                <div className={css.root}>
                    {status === STATUSES[0] && (
                        <span>{t`Сообщение отправляется...`}</span>
                    )}
                    {status === STATUSES[1] && (
                        <span className={css.textRed}>
                            {t`Сообщение не отправлено`}
                        </span>
                    )}
                    {canRetry && (
                        <div>
                            <span
                                className={css.textBlue}
                                title={status}
                                onClick={retry(msgId)}
                            >
                                {t`Отправить еще раз`}
                            </span>
                        </div>
                        )}
                </div>
            )}
        </React.Fragment>
    )
};

Processing.propTypes = {
    isSpellingError: PropTypes.bool,
    msgId: PropTypes.any,
    status: PropTypes.string,
    retry: PropTypes.func
};
